export default "__VITE_ASSET__DlJQiniv__"